import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SearchBox from "../components/SearchBox";

export default function Home() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <main className="flex-grow container py-12 px-4 md:px-8">
        {/* Seção principal com buscador e copy persuasiva */}
        <section className="bg-white shadow-lg rounded-2xl p-8 md:p-12 text-center">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Encontre o melhor preço em segundos 🔍
          </h1>
          <p className="text-gray-700 text-lg md:text-xl mb-6 max-w-3xl mx-auto">
            Economize tempo e dinheiro com o{" "}
            <span className="font-semibold text-blue-600">AcheiPreço</span>. Compare produtos em diversos marketplaces confiáveis e descubra as melhores ofertas.
          </p>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            ✅ Totalmente gratuito e seguro <br />
            ✅ Resultados atualizados em tempo real
          </p>

          {/* Buscador central */}
          <div className="flex justify-center">
            <div className="w-full max-w-2xl">
              <SearchBox /> {/* <-- buscador funcionando */}
            </div>
          </div>
        </section>

        {/* Seção de confiança / prova social */}
        <section className="mt-12 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
            Por que usar o AcheiPreço?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="bg-white shadow-md rounded-xl p-6 hover:shadow-xl transition">
              <h3 className="font-semibold text-lg mb-2">Economia Garantida</h3>
              <p className="text-gray-600 text-sm">
                Compare preços em dezenas de marketplaces e nunca pague mais caro.
              </p>
            </div>
            <div className="bg-white shadow-md rounded-xl p-6 hover:shadow-xl transition">
              <h3 className="font-semibold text-lg mb-2">Seguro e Transparente</h3>
              <p className="text-gray-600 text-sm">
                Marketplaces confiáveis para você comprar sem medo.
              </p>
            </div>
            <div className="bg-white shadow-md rounded-xl p-6 hover:shadow-xl transition">
              <h3 className="font-semibold text-lg mb-2">Rápido e Prático</h3>
              <p className="text-gray-600 text-sm">
                Resultados instantâneos, mostrando os produtos mais baratos e melhor avaliados.
              </p>
            </div>
          </div>
        </section>

        {/* Seção de SEO/Conteúdo rico para Google */}
        <section className="mt-12 max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Compare preços de produtos populares
          </h2>
          <p className="text-gray-600 mb-4">
            Encontre rapidamente ofertas de celulares, eletrônicos, eletrodomésticos, roupas, tênis, acessórios e muito mais.
          </p>
          <p className="text-gray-600 text-sm">
            Nosso comparador de preços cobre os principais marketplaces: Amazon, Mercado Livre, Magalu, AliExpress e outros. Economize tempo e dinheiro usando o AcheiPreço.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
}
